import { render, staticRenderFns } from "./Hubs.vue?vue&type=template&id=38e8b326&scoped=true&"
import script from "./Hubs.vue?vue&type=script&lang=js&"
export * from "./Hubs.vue?vue&type=script&lang=js&"
import style0 from "./Hubs.vue?vue&type=style&index=0&id=38e8b326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e8b326",
  null
  
)

export default component.exports